import React, { useState, useEffect } from "react";
import "./formLeaderAttribute.css";
import { Form, Input, Button, Typography, Space, Row, Col, Select, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import DraggableBehaviors from "../draggableBehaviors/DraggableBehaviors";
import OrderingAPI from "../../utils/OrderingAPI";

const { Text, Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const FormLeaderAttribute = (props) => {
    const [isEditing, setIsEditing] = useState(false);

    // Funciones de edición y guardado
    const handleEditClick = () => setIsEditing(true);
    const handleSaveClick = () => {
        setIsEditing(false);
        props.saveLeaderAttribute();
    };

    const handleCreateClick = () => {
        props.saveLeaderAttribute();
    };

    useEffect(() => {
        setIsEditing(false);
    }, [props.latId]);

    const handleBehaviorChange = (index, value) => {
        // ✅ Clonar el array de descriptores sin modificar el original
        const updatedBehaviors = [...props.latBehaviors];
        updatedBehaviors[index].lab_behavior = value
        props.setLatBehaviors(updatedBehaviors);
    };

    const addBehavior = () => {
        const updatedBehaviors = [...(props.latBehaviors || [])];
        updatedBehaviors.push({ lab_id: null, lab_behavior: "" });
        props.setLatBehaviors(updatedBehaviors);
    };

    const removeBehavior = (index) => {
        const updatedBehaviors = (props.latBehaviors || []).filter((_, i) => i !== index);
        props.setLatBehaviors(updatedBehaviors);
    };

    const handleBehaviorOrderChange = (orderData) => {
        // Esta función maneja el cambio de orden temporal sin guardar
        console.log('Orden temporal cambiado:', orderData);
    };

    const handleSaveBehaviorOrder = async (orderData) => {
        try {
            // Hacer llamada API para actualizar el orden usando OrderingAPI
            const response = await OrderingAPI.updateLeaderBehaviorsOrder(orderData);

            if (response.success) {
                console.log('Orden guardado exitosamente');
                // Opcionalmente mostrar mensaje de éxito
            }
        } catch (error) {
            console.error('Error al guardar orden:', error);
        }
    };

    // Convertir behaviors para el componente DraggableBehaviors
    const getBehaviorTexts = () => {
        return (props.latBehaviors || []).map(behavior => behavior.lab_behavior || '');
    };

    // Pasar behaviors completos con IDs
    const getBehaviorsWithIds = () => {
        return (props.latBehaviors || []);
    };

    return (
        <Form layout="horizontal">
            {/* Nombre del atributo del líder */}
            <Row align="middle" style={{ marginBottom: 10 }}>
                <Col span={4}><Text style={{ color: "#00b7a3", fontSize: "16px", fontWeight: 500 }}>Nombre:</Text></Col>
                <Col span={20}>
                    {isEditing || props.newLeaderAttribute ? (
                        <Input 
                            value={props.latLeaderAttribute} 
                            onChange={(e) => props.setLatLeaderAttribute(e.target.value.toUpperCase())} 
                        />
                    ) : (
                        <Text>{props.latLeaderAttribute || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Descripción del atributo del líder */}
            <Row align="middle" style={{ marginBottom: 10 }}>
                <Col span={4}><Text style={{ color: "#00b7a3", fontSize: "16px", fontWeight: 500 }}>Descripción:</Text></Col>
                <Col span={20}>
                    {isEditing || props.newLeaderAttribute ? (
                        <Input 
                            value={props.latDescription} 
                            onChange={(e) => props.setLatDescription(e.target.value.toUpperCase())} 
                        />
                    ) : (
                        <Text>{props.latDescription || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Comportamientos del atributo */}
            <Row style={{ marginBottom: 10 }}>
                <Col span={4}><Text style={{ color: "#00b7a3", fontSize: "16px", fontWeight: 500 }}>Comportamientos:</Text></Col>
                <Col span={20} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {!props.newLeaderAttribute && props.latId && (props.latBehaviors || []).length > 0 && props.onDeleteAllBehaviors && (
                        <Popconfirm
                            title="¿Eliminar todos los comportamientos?"
                            description="Esta acción eliminará todos los comportamientos de este atributo. No se puede deshacer."
                            onConfirm={() => props.onDeleteAllBehaviors(props.latId)}
                            okText="Sí, eliminar"
                            cancelText="Cancelar"
                            okButtonProps={{ danger: true }}
                        >
                            <Button danger size="small" icon={<DeleteOutlined />}>
                                Eliminar todos los comportamientos ({(props.latBehaviors || []).length})
                            </Button>
                        </Popconfirm>
                    )}
                </Col>
            </Row>
            
            <DraggableBehaviors
                behaviors={getBehaviorsWithIds()}
                isEditing={isEditing || props.newLeaderAttribute}
                onBehaviorChange={handleBehaviorChange}
                onBehaviorAdd={addBehavior}
                onBehaviorDelete={removeBehavior}
                onOrderChange={handleBehaviorOrderChange}
                onSaveOrder={handleSaveBehaviorOrder}
                attributeId={props.latId}
                attributeType="leader"
            />

            {/* Botones */}
            <Row justify="end" style={{ marginTop: 20 }}>
                <Space>
                    {props.newLeaderAttribute ? (
                        <Button type="primary" onClick={handleCreateClick}>Guardar</Button>
                    ) : isEditing ? (
                        <>
                            <Button type="primary" onClick={handleSaveClick}>Guardar</Button>
                            <Button onClick={() => setIsEditing(false)}>Cancelar</Button>
                        </>
                    ) : (
                        <Button type="default" onClick={handleEditClick}>Editar</Button>
                    )}
                </Space>
            </Row>
        </Form>
    );
};

export default FormLeaderAttribute;
